/**
 * Created by dyc on 2018/4/1.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    Router,
    Route,
    withRouter,
    IndexRoute,
    hashHistory,
} from 'react-router';
import {
    Button,
    Row,
    Col,
    Modal,
    Input,
    message,
    Select,
    InputNumber,
    DatePicker,
    Table,
    Upload,
    Icon,
    Card,
    Tooltip,
    Cascader,
    Checkbox,
    Notification,
    Tag,
    Progress
} from 'antd';
import {
    DmsTab,
    TableView,
} from '../../components';
import {
    openNotice,
    downLoadTemplate,
    toImportExcel1,
} from 'Utils';
import {
    getPro,
    create,
    getDetail,
    getTiAddress,
    getDongList,
    getOrderDetails,
    createForSave,
    giveBefore, updateOrderLineAttribute,
} from '../../service/order';
import {getGdList} from '../../service/shoppingCar';
import moment from 'moment';
import './order.css';
import fenPi from './fenpi.png';
import {treeList2} from '../../service/org';

const Option = Select.Option;
const confirm = Modal.confirm;
const {TextArea} = Input;

class CustomOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            button_limits_end: {},
            passId: '',
            /*获取登录人信息数据*/
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || '',
            /*获取详情所需code*/
            purchaseId: JSON.parse(window.sessionStorage.getItem('purchaseId') || '{}') || '',
            /*获取生成订单数据*/
            orderData: JSON.parse(window.sessionStorage.getItem('generate_orders') || '{}') || '',
            orderData2: JSON.parse(window.sessionStorage.getItem('generate_orders1') || '{}') || '',
            /*获取订单商品列表*/
            orderListData: JSON.parse(window.sessionStorage.getItem('list_orders') || '{}') || '',
            /*获取预订单列表*/
            passParse: JSON.parse(window.sessionStorage.getItem('passParse') || '{}') || '',
            /*获取预定制列表*/
            dingPassParse: JSON.parse(window.sessionStorage.getItem('dingPassParse') || '{}') || '',
            opts: ['订单详情 -- 新增常规订单'],
            orderSubmit3: 'block',
            orderSubmit2: 'none',
            orderSubmit4: 'none',
            channelCode: JSON.parse(window.sessionStorage.getItem('generate_orders')) ? JSON.parse(window.sessionStorage.getItem('generate_orders')).channelCode : '',
            deliveryShowprice: JSON.parse(window.sessionStorage.getItem('generate_orders')) ? JSON.parse(window.sessionStorage.getItem('generate_orders')).deliveryShowprice : '',
            key: 0,
            showBackBtn: false,
            visible: false,
            usable: false,
            modalVisible: false,
            quickVisible: false,
            detailData: {},    //获取的用户信息
            optionAddress: [],    //获取的收货地址（下拉选择）
            tiAddress: [],    //获取的提货地址（下拉选择）
            optionTerminal: [],    //获取的项目信息（含终端）（下拉选择）
            remark: '',    //输入的备注信息
            valueRemark: [],    //输入的备注信息
            viewCount: '',
            customerOrderCode: '',      //输入的客户订单号
            gatherRealityAddress: '',  //实际收货地址选中
            gatherRealityAddress1: '',  //实际收货地址选中
            gatherRealityAddress2: '',  //实际收货地址选中
            terminalMessage: '',
            tiAddress2: '',
            projectMessage: '',     //项目信息（含终端）选中
            addRows: [],
            addTotal: 1,
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
            name: '',
            stockType: '',
            code: '',
            // titleStr:'例：生产周期：[1,3]代表：有库存生产需要:1天，无库存:3天;\r\n___________非库存类产品，显示为准确的生产天数',
            addSearchObj: {
                s: 10,
                p: 1,
            },
            //李 新增
            lastsearch: '',
            submitRows: [],
            add: [],
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1,
            },
            day: [],
            productionCycle: [],
            date: [],
            xiaFuJia: [],
            weiFaYunCount: [],
            defDeliverDay: [],
            productName: [],
            cadreRepertory: [],
            onhand: [],
            reserveLineId: [],
            reserveQuantity: [],
            xinzengShow: false,
            xinzengShow1: false,
            shouHuoShow: false,
            allPrice: 0,
            realyPrice: 0,
            cutPrice: 0,
            quickString: '',//智能输入内容
            quickResult: [],
            dataSource2: [],
            number2: 1,
            count2: 1,
            detailData3: [],
            // disabledCount:false,
            loading: true,
            id6: false,
            giveBackStatus: 0,
            reserveHid: '',
            confirmvisible: false,
            confirmLoading: false,
            quickLoading: false,
            cascaderValue: [],
            tree: [],
            ts_disabled: false,
            ts_checked: false,
            ls_checked: false,
            proDetailType: '',
            apiFlag: true,
            wholeDelivery: 'N', //整单发货
            ////
            activeKey: '', // product: 按物料选择; merchandise: 按商品选型
            ordinaryOrderFlag: '', //普通订单开单权限
            minPackageFlag: '',
            finishCount: 0,
            postCount: 1
        };
        this.price = this.price.bind(this);
        this.refreshList = this.refreshList.bind(this);

        // 重置样式
        window['resetIframeStyle'] = function (el) {
            el.setAttribute('class', '');
            el.style.border = '0px solid #dcdcdc';
            el.style.overflowX = 'hidden';
        }
    };

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(4);
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    goBack() {
        // hashHistory.goBack();
        this.goView('order');
    }

    getData() {
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code;
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code;
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data,
                });
            } else {
                openNotice('warning', result.message);
            }
        });
    }

    CascaderClick() {
        if (this.state.tree == null || this.state.tree == '') {
            this.getData();
        }
    }

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    };

    CascaderRender = (label) => {
        return label[label.length - 1];
    };

    CascaderChange = (value, selectedOptions) => {
        if (value.length > 0) {
            this.setState({
                proDetailType: selectedOptions[2].value,
                proDetailName: selectedOptions[2].label,
                cascaderValue: value,
                addSearchObj: {...this.state.addSearchObj, p: 1},
            });
        } else {
            this.setState({proDetailType: '', proDetailName: '', cascaderValue: []});
        }
    };

    /*选择外层列表*/
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };

    /*外层翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.initData();
        });
    };

    /*选择物料弹窗*/
    searchHandler = (key) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return;
        }
        this.setState({visible: true, activeKey: key});
        // this.getAddArray();
    };

    openModal = (record, index, event) => {
        // console.log(record);
        // console.log(index);
        // console.log(event);
        var getList = this.state.submitRows[index].orderProductPartList || [];
        var x = this.state.submitRows[index].productName;
        this.setState({dataSource2: getList, dataSource3: index, productName2: x});
        this.setState({modalVisible: true});
    };

    /*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        var add = [];
        for (var i = 0; i < selectedRows.length; i++) {
            add = [...selectedRows];
            add[i].pickProAddress = this.state.tiAddress2;
            add[i].productName = selectedRows[i].name;
            add[i].productId = selectedRows[i].id;
        }
        this.setState({
            selectedRowKeys: selectedRowKeys,
            add: add,
        });
    };

    onSelectRadio = (record, selected, selectedRows) => {
        this.setState({
            pId: record.id,
            pListId: record.priceListId,
        });
    };

    /*选择物料列表翻页*/
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getAddArray();
        });
    };

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value,
        });
    };

    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value,
        });
    };

    tsChange = (e) => {
        this.setState({
            stockType: e.target.checked ? '退市' : '',
            ts_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1},
        });
    };

    lsChange = (e) => {
        this.setState({
            ls_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1},
        });
    };

    //物料查询界面库存搜索
    stockChange = (value) => {
        switch (value) {
            case '0':
                this.setState({
                    stockType: '库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '1':
                this.setState({
                    stockType: '非库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '2':
                this.setState({
                    stockType: '定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '3':
                this.setState({
                    stockType: '专属定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '4':
                this.setState({
                    stockType: '退市',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            default :
                this.setState({
                    stockType: '',
                    ts_disabled: false,
                    ts_checked: false,
                });
                break;
        }
    }

    /*选择物料列表数据(点击搜索)*/
    getAddArray = () => {
        if (this.state.name == '') {
            openNotice('warning', '请输入物料名称或编码');
            return;
        }
        //李 新增
        if (this.state.name != this.state.lastsearch) {
            this.state.addSearchObj.p = 1;
            this.state.lastsearch = this.state.name;
        }
        this.setState({loading: true});
        getPro({
            channelCode: this.state.orderData.channelCode,
            customerId: this.state.orderData.thirdId,
            keyword: this.state.code,
            name: this.state.name,
            stockType: this.state.stockType,
            proDetailType: this.state.proDetailType,
            proDetailName: this.state.proDetailName,
            delisting: this.state.ts_checked,
            historyOpen: this.state.ls_checked,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s,
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows: result.data,
                    addTotal: result.total,
                    loading: false,
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        });
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.getAddArray();
        }
    };

    /*点击确定保存*/
    addSaveHandler = (value) => {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择至少一条物料列表数据');
            return;
        }
        if (this.state.selectedRowKeys.pickProAddress === 0) {
            openNotice('warning', '请选择提货地点');
            return;
        }
        var x = 0;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            for (var j = 0; j < this.state.selectedRowKeys.length; j++) {
                if (this.state.submitRows[i].productId == this.state.selectedRowKeys[j]) {
                    x = 1;
                }
            }
        }
        /*确认*/
        this.doSave(value);
        /*清空信息*/
        this.doClear();
        if (this.state.orgId && this.state.orgId != '') {
            for (var i = 0; i < this.state.submitRows.length; i++) {
                console.log(1);
            }
        }
        if (value != 1) {
            this.setState({visible: false});
            this.setState({modalVisible: false});
        }
    };

    /*添加行*/
    addSave = (record, index, value) => {
        const self = this;
        var x = 0;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            if (this.state.submitRows[i].productId == record.id || this.state.submitRows[i].productId == record.productId) {
                x = 1;
            }
        }
        if (x == 1) {
            openNotice('warning', '商品已添加', null, 1);
            return;
        }
        var submitRows = [...this.state.submitRows];
        var addSave = {...record};
        addSave.productId = addSave.id;
        addSave.id = window.myTemp++;
        addSave.productName = addSave.name;
        if (addSave.count == null) {
            addSave.count = 0;
        }
        if (self.state.orgName) {
            addSave.delvId = self.state.orgId;
            addSave.pickProAddress = self.state.orgName;
        }
        submitRows.push(addSave);
        self.setState({submitRows: submitRows});
        openNotice('success', '商品添加成功', null, 1);
    };

    doSave = (value) => {
        const self = this;
        var submitRows = [...this.state.submitRows];
        for (let i = 0; i < self.state.add.length; i++) {
            self.state.add[i].id = window.myTemp++;
            self.state.add[i].count = 0; //TODO
            if (self.state.orgName) {
                self.state.add[i].delvId = self.state.orgId;
                self.state.add[i].pickProAddress = self.state.orgName;
            }
            submitRows.push(self.state.add[i]);
        }
        self.setState({submitRows: submitRows});
        if (value != 1) {
            self.setState({visible: false});
            self.setState({modalVisible: false});
        }
    };

    doClear = () => {
        this.setState({
            name: '',
            code: '',
            add: [],
            selectedRowKeys: [],
        });
    };

    /*点击保存提交数据*/
    createHandler = (value) => {
        var self = this;
        self.setState({confirmLoading: true});
        if (this.state.ordinaryOrderFlag == 'N') {
            openNotice('warning', '该单位没有常规订单的开单权限');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;

        var createObj = {};
        createObj = {
            'amount': this.state.allPrice,
            'buyCompany': orderData.PurchaseUnit,
            'channel': orderData.channel,
            'contacts': this.state.recipientName,
            'createdDate': detailData.createdDate,
            'cusId': orderData.thirdId,
            'customerCode': detailData.cusCode,
            'customerName': detailData.cusName,
            'customerOrderCode': this.state.customerOrderCode,
            'discountRate': orderData.defDiscount,
            'gatherRealityAddress': this.state.gatherRealityAddress || '',
            'guaranteeQuality': 0,
            'orderBackMsg': '',
            'orderType': '1', /*1常规订单2项目订单3合作伙伴订单*/
            'phone': this.state.mobile,
            'projectMessage': this.state.projectMessage,
            'projectName': detailData.name,
            'remainingSum': orderData.sxeAmount,
            'remark': this.state.remark,
            'removeFlag': 0,
            'salesmanName': this.state.salesmanName,
            'pullmanName': this.state.pullmanName,
            'deliveryShowprice': this.state.deliveryShowprice,
            'submitType': 1, /*提交1保存0*/
            'userId': userData.id,
            'buyCompanyId': this.state.detailData.id,
            'gatherAddressId': this.state.receiveAddressId,
            'creditExtensionId': this.state.detailData.id,
            'orgId': 82,
            'projectId': this.state.projectId,
            'businessChannel': this.state.businessChannel,
            'discountPoolSum': orderData.discountAmount,
            'realityAmount': this.state.realyPrice,
            'isSecond': 0,
            'channelCode': orderData.channelCode,
            'cusUserId': detailData.cusUserId || '',
            'getProCode': this.state.getProCode || '',
            'reserveHid': this.state.reserveHid || '',
            'orderSource': orderData.orderSource,
            'wholeDelivery': this.state.wholeDelivery,
            'sourceNo': this.state.sourceNo
        };
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (self.props.params.id == 6) {
            createObj.headerId = self.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (value == 2) {
            createObj.submitType = 2;
        }
        if (this.props.params.id == 9) {
            createObj.id = this.props.params.orderId;
            if (this.props.params.type && this.props.params.type == '再来一单') {
                createObj.id = '';
                createObj.orderSource = null;
                delete createObj.getProCode;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(self.state.submitRows));

        for (var i = 0; i < this.state.submitRows.length; i++) {
            obj2[i].availableReferenceQuantity = this.state.submitRows[i].onhand; //参考可用量
            obj2[i].price = this.state.submitRows[i].xiaFuJia; //下浮价
            obj2[i].weiFaYunCount = this.state.submitRows[i].weiFaYunCount;
            obj2[i].logisticsCycle = this.state.submitRows[i].day;
            obj2[i].productionCycle = this.state.submitRows[i].productionCycle;
            obj2[i].referenceArrivalDate = this.state.submitRows[i].date;
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            if (obj2[i].delvId == null) {
                openNotice('error', '请选择订单行上的提货地点', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                this.setState({usable: false});
                return;
            }

            if (obj2[i].price == null || obj2[i].price == '') {
                openNotice('error', obj2[i].itemNum + '获取下浮价失败，请删除该行重新添加，或修改数量重新获取下浮价', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                this.setState({usable: false});
                return
            }

            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到提货物流（' + obj2[i].pickProAddress + '），或面价是否正常。', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                this.setState({usable: false});
                return;
            }
            switch (this.state.submitRows[i].proLine) {
                case '元器件':
                    obj2[i].proLine = '01';
                    break;
                case '电工':
                    obj2[i].proLine = '02';
                    break;
                case '电表':
                    obj2[i].proLine = '03';
                    break;
                case '变频器':
                    obj2[i].proLine = '04';
                    break;
                case '天e':
                    obj2[i].proLine = '05';
                    break;
                case 'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }
            if (this.props.params.id == 5) {
                if (this.state.dingPassParse.length - 1 > i) {
                    obj2[i].bookId = this.state.submitRows[i].bookId;
                }
            }
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            obj2[i].removeFlag = 0;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
            }
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if ((self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0)) {
                var existUnFaYun = 1;
            }
        }
        createObj.productList = obj2;
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({confirmvisible: false, confirmLoading: false});
                        self.setState({usable: false});
                        return;
                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({confirmvisible: false, confirmLoading: false});
                            self.setState({usable: false});
                            return;
                        } else {
                            /*if (self.state.giveBackStatus == 4) {
               createObj.headerId = this.state.headerId2;
               giveBefore(createObj).then(result => {
               if (result.status && result.code == 200) {
               openNotice('success', '创建成功', '');
               self.goView('order');
               } else {
               openNotice('error', '创建失败', result.message || '');
               self.setState({usable:false});
               return
               }
               });
               } else {*/
                            create(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    updateOrderLineAttribute(result.data.sourceNo);
                                    openNotice('success', '创建成功', '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.goView('order');
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.setState({usable: false});
                                    return;
                                }
                            });
                            //}
                        }
                    }
                },
                onCancel() {
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                    return;
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                self.setState({usable: false});
                return;
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                    return;
                } else {
                    if (self.state.giveBackStatus == 4) {
                        createObj.headerId = this.state.headerId2;
                        giveBefore(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                                return;
                            }
                        });
                    } else {
                        create(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                                return;
                            }
                        });
                    }
                }
            }
        }
    };

    /*保存功能*/
    createHandler2 = (value) => {
        var self = this;
        if (this.state.ordinaryOrderFlag == 'N') {
            openNotice('warning', '该单位没有常规订单的开单权限');
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return;
        }
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;
        //总金额重新计算
        var price = 0;
        var allPrice = 0;
        var realyPrice = 0;
        var allRealyPrice = 0;
        var everyPrice = 0;
        var everyRealyPrice = 0;
        var everyCount = 0;
        for (var i = 0; i < self.state.submitRows.length; i++) {
            everyCount = self.state.submitRows[i].count || 0;
            everyPrice = self.state.submitRows[i].showPrice || 0;
            everyRealyPrice = self.state.submitRows[i].xiaFuJia || 0;
            allPrice = everyCount * everyPrice;
            price = price + allPrice;
            allRealyPrice = everyCount * everyRealyPrice;
            realyPrice = realyPrice + allRealyPrice;
        }
        //存储参数
        var createObj = {};
        createObj = {
            'amount': this.state.allPrice,
            'buyCompany': orderData.PurchaseUnit,
            'channel': orderData.channel,
            'contacts': this.state.recipientName,
            'createdDate': detailData.createdDate,
            'cusId': orderData.thirdId,
            'customerCode': detailData.cusCode,
            'customerName': detailData.cusName,
            'customerOrderCode': this.state.customerOrderCode,
            'discountRate': orderData.defDiscount,
            'gatherRealityAddress': this.state.gatherRealityAddress || '',
            'guaranteeQuality': 0,
            'orderBackMsg': '',
            'orderType': '1', /*1常规订单2项目订单3合作伙伴订单*/
            'phone': this.state.mobile,
            'projectMessage': this.state.projectMessage,
            'projectName': detailData.name,
            'remainingSum': orderData.sxeAmount,
            'remark': this.state.remark,
            'removeFlag': 0,
            'salesmanName': this.state.salesmanName,
            'pullmanName': this.state.pullmanName,
            'deliveryShowprice': this.state.deliveryShowprice,
            'submitType': 0, /*提交1保存0*/
            'userId': userData.id,
            'buyCompanyId': this.state.detailData.id,
            'gatherAddressId': this.state.receiveAddressId,
            'creditExtensionId': this.state.detailData.id,
            'orgId': 82,
            'projectId': this.state.projectId,
            'businessChannel': this.state.businessChannel,
            'discountPoolSum': orderData.discountAmount,
            'realityAmount': realyPrice,
            'isSecond': 0,
            'channelCode': orderData.channelCode,
            'cusUserId': detailData.cusUserId || '',
            'getProCode': this.state.getProCode || '',
            'reserveHid': this.state.reserveHid || '',
            'orderSource': orderData.orderSource,
            'wholeDelivery': this.state.wholeDelivery,
            'sourceNo': this.state.sourceNo
        };
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (self.props.params.id == 6) {
            createObj.headerId = self.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (self.props.params.id == 9) {
            createObj.id = self.props.params.orderId;
            if (self.props.params.type && self.props.params.type == '再来一单') {
                createObj.id = '';
                createObj.orderSource = null;
                delete createObj.getProCode;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(this.state.submitRows));
        for (var i = 0; i < self.state.submitRows.length; i++) {
            obj2[i].availableReferenceQuantity = this.state.submitRows[i].onhand;
            obj2[i].weiFaYunCount = this.state.submitRows[i].weiFaYunCount;
            obj2[i].logisticsCycle = this.state.submitRows[i].day;
            obj2[i].productionCycle = this.state.submitRows[i].productionCycle;
            obj2[i].referenceArrivalDate = this.state.submitRows[i].date;
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            obj2[i].price = this.state.submitRows[i].xiaFuJia;
            if (obj2[i].delvId == null) {
                openNotice('error', '请选择订单行上的提货地点', '');
                this.setState({usable: false});
                return;
            }
            if (obj2[i].price == null || obj2[i].price == '') {
                openNotice('error', obj2[i].itemNum + '获取下浮价失败，请删除该行重新添加，或修改数量重新获取下浮价', '');
                this.setState({usable: false});
                return
            }

            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到提货物流（' + obj2[i].pickProAddress + '），或面价是否正常。', '');
                this.setState({usable: false});
                return;
            }
            switch (this.state.submitRows[i].proLine) {
                case '元器件':
                    obj2[i].proLine = '01';
                    break;
                case '电工':
                    obj2[i].proLine = '02';
                    break;
                case '电表':
                    obj2[i].proLine = '03';
                    break;
                case '变频器':
                    obj2[i].proLine = '04';
                    break;
                case '天e':
                    obj2[i].proLine = '05';
                    break;
                case 'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
            }
            obj2[i].removeFlag = 0;
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if (self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0) {
                var existUnFaYun = 1;
            }
        }
        createObj.productList = obj2;
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({usable: false});
                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({usable: false});
                        } else {
                            createForSave(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    openNotice('success', '保存成功', '');
                                    self.setState({getProCode: result.data.getProCode});
                                    self.setState({sourceNo: result.data.sourceNo});
                                    self.setState({orderSubmit4: 'block'});
                                    self.goView(`order/addConventional1/${9}&${result.data.id}`);
                                    self.setState({usable: false, shouHuoShow: false, xinzengShow1: false});
                                    // self.goView('order');
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({usable: false});
                                }
                            });
                        }
                    }
                },
                onCancel() {
                    self.setState({usable: false});
                    return;
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({usable: false});
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({usable: false});
                } else {
                    createForSave(createObj).then(result => {
                        if (result.status && result.code == 200) {
                            openNotice('success', '保存成功', '');
                            self.setState({getProCode: result.data.getProCode});
                            self.setState({sourceNo: result.data.sourceNo});
                            self.setState({orderSubmit4: 'block'});
                            self.goView(`order/addConventional1/${9}&${result.data.id}`);
                            self.setState({usable: false, shouHuoShow: false, xinzengShow1: false});
                            // self.goView('order');
                        } else {
                            openNotice('error', '创建失败', result.message || '');
                            self.setState({usable: false});
                        }
                    });
                }
            }
        }
    };

    deliveryShowpriceChange = (value) => {
        this.setState({
            deliveryShowprice: value || '',
        });
    };

    wholeDeliveryChange = (value) => {
        this.setState({
            wholeDelivery: value || '',
        });
    };

    /*获取数据*/
    initData() {
        var orderData = this.state.orderData;
        this.setState({
            loading: true,
        });
        /*获取详情数据*/
        const self = this;
        var purchaseId = this.state.purchaseId;
        var thirdId = this.state.orderData.thirdId;
        getDetail(purchaseId, thirdId).then(res => {
            var x = res.data;
            var timestamp = new Date().getTime();
            x.createdDate = timestamp;
            self.setState({
                detailData: x,
                optionAddress: res.data.addressList || '',
                optionTerminal: res.data.terminalList || '',
                ordinaryOrderFlag: res.data.ordinaryOrderFlag || '',
                minPackageFlag: res.data.minPackageFlag || '',
                loading: false,
            }, () => {
                if (res.data.addressList.length == 1 && this.props.params.id != 6) {
                    this.setState({
                        gatherRealityAddress2: res.data.addressList[0].id + '',
                        gatherRealityAddress: res.data.addressList[0].detailAddress,
                        recipientName: res.data.addressList[0].recipientName,
                        mobile: res.data.addressList[0].mobile,
                        receiveAddressId: res.data.addressList[0].id,
                        deliveryShowprice: res.data.addressList[0].deliveryShowPrice || 'Y',
                        xinzengShow: false,
                        xinzengShow1: false,
                        loading: false,
                    });
                }
            });
        });
        getTiAddress(orderData.cusName, purchaseId).then(res => {
            self.setState({
                tiAddress: res.data || '',
            }, () => {
                if (res.data.length == 1 && this.props.params.id != 4) {
                    self.setState({
                        defaultAddress: res.data[0].delvName,
                        usable: true,
                        orgId: res.data[0].id,
                        orgName: res.data[0].delvName
                    });
                }
            });

        });
    }

    /*实际收货地址选中*/
    addressChange = (value) => {
        const self = this;
        this.setState({loading: true});
        let address = this.state.optionAddress.filter(x => x.id == value)[0];
        var recipientName = address.recipientName;
        var receiveAddressId = address.id;
        var mobile = address.mobile;
        var detailAddress = address.detailAddress;
        var deliveryShowPrice = address.deliveryShowPrice;
        self.setState({
            usable: true,
            receiveAddressId: receiveAddressId
        }, () => {
            this.refreshList();
        });
        this.setState({
            gatherRealityAddress2: value,
            gatherRealityAddress: detailAddress || '',
            recipientName: recipientName,
            mobile: mobile,
            receiveAddressId: receiveAddressId,
            xinzengShow: false,
            xinzengShow1: false,
            loading: false,
            deliveryShowprice: deliveryShowPrice || 'Y'
        });
    };

    /*提货地点修改*/
    addressChange2 = (value, option) => {
        var index = option.props.recordIndex;
        this.setState({
            ...this.state,
            submitRows: this.state.submitRows.map((x, index) => {
                if (index == option.props.recordIndex) {
                    return {
                        ...x,
                        pickProAddress: value,
                    };
                } else {
                    return x;
                }
            }),
        });
        var self = this;
        let list = this.state.tiAddress;
        let messagess = {};
        for (let i = 0; i < list.length; i++) {
            if (list[i].id === parseInt(value)) {
                messagess = list[i];
                break;
            }
        }
        var submitRows = [...self.state.submitRows];
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        submitRows[index].pickProAddress = messagess.delvName + '';
        submitRows[index].delvId = parseInt(value);
        submitRows[index].pickProAddressId = parseInt(value);
        self.setState({submitRows: submitRows});
        if (self.props.params.id != 4) {
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: parseInt(self.state.orderData.thirdId),
                purchaseId: self.state.detailData.id,
                pickProAddress: messagess.delvName,
                pickProAddressId: messagess.id,
                proId: self.state.submitRows[index].productId,
                count: self.state.submitRows[index].count || 0,
                receiveAddressId: self.state.receiveAddressId,
            };
        } else {
            if (index < self.state.orderListData.length) {
                var postList = {
                    channelCode: self.state.orderData.channelCode,
                    customerId: parseInt(self.state.orderData.thirdId),
                    purchaseId: self.state.detailData.id,
                    pickProAddress: messagess.delvName,
                    pickProAddressId: messagess.id,
                    proId: self.state.orderListData[index].productId,
                    count: self.state.submitRows[index].count || 0,
                    receiveAddressId: self.state.receiveAddressId,
                };
            } else {
                var postList = {
                    channelCode: self.state.orderData.channelCode,
                    customerId: parseInt(self.state.orderData.thirdId),
                    purchaseId: self.state.detailData.id,
                    pickProAddress: messagess.delvName,
                    pickProAddressId: messagess.id,
                    proId: self.state.submitRows[index].productId,
                    count: self.state.submitRows[index].count || 0,
                    receiveAddressId: self.state.receiveAddressId,
                };
            }
        }
        postCount++;
        getDongList(postList).then(res => {
            if (res.code == 200 && res.data) {
                finishCount++;
                if (postCount == finishCount) {
                    self.setState({
                        usable: false,
                    });
                }
                var day = self.state.day;
                var date = self.state.date;
                var xiaFuJia = self.state.xiaFuJia;
                var weiFaYunCount = self.state.weiFaYunCount;
                var onhand = self.state.onhand;
                var productionCycle = self.state.productionCycle;
                var defDeliverDay = self.state.defDeliverDay;
                var productName = self.state.productName;
                var cadreRepertory = self.state.cadreRepertory;
                var reserveLineId = self.state.reserveLineId;
                var reserveQuantity = self.state.reserveQuantity;
                day[index] = res.data.day;
                date[index] = res.data.date;
                xiaFuJia[index] = res.data.xiaFuJia;
                weiFaYunCount[index] = res.data.weiFaYunCount;
                onhand[index] = res.data.onhand;
                productionCycle[index] = res.data.productionCycle;
                defDeliverDay[index] = res.data.defDeliverDay;
                productName[index] = res.data.productName;
                cadreRepertory[index] = res.data.cadreRepertory;
                reserveLineId[index] = res.data.reserveLineId;
                reserveQuantity[index] = res.data.reserveQuantity;
                /*if (res.data.date == '待评审') {
                    submitRows[index].deliveryArrivalDate = null;
                } else {
                    submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                }*/
                submitRows[index].date = res.data.date;
                submitRows[index].cadreRepertory = res.data.cadreRepertory;
                submitRows[index].onhand = res.data.onhand;
                submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                submitRows[index].productionCycle = res.data.productionCycle;
                submitRows[index].day = res.data.day;
                submitRows[index].xiaFuJia = res.data.xiaFuJia;
                submitRows[index].priceRate = res.data.priceRate;
                submitRows[index].showPrice = res.data.listPrice; //刷新面价
                if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                    if (res.data.reserveLineId != "") {
                        if (res.data.reserveQuantity < submitRows[index].count) {
                            submitRows[index].reserveLid = null;
                        } else {
                            submitRows[index].reserveLid = res.data.reserveLineId;
                        }
                    }
                }
                self.setState({
                    day: day,
                    date: date,
                    xiaFuJia: xiaFuJia,
                    weiFaYunCount: weiFaYunCount,
                    onhand: onhand,
                    productionCycle: productionCycle,
                    defDeliverDay: defDeliverDay,
                    productName: productName,
                    cadreRepertory: cadreRepertory,
                    reserveLineId: reserveLineId,
                    reserveQuantity: reserveQuantity,
                    submitRows: submitRows,
                }, () => {
                    self.price();
                });
            } else {
                openNotice('warning', '数据获取失败，请确认实际收货地址、提货地点、开单数量是否正确');
            }
        });
    };

    /*项目信息（含终端）选中*/
    terminalChange = (value) => {
        var messagess = this.state.optionTerminal.filter(x => x.id == value)[0];
        var seller = messagess.seller;
        this.setState({
            terminalMessage: value,
            projectMessage: messagess.projectMsg,
            projectId: value,
            seller: seller,
        });
    };

    /*备注信息填写*/
    remarkChange = (event) => {
        this.setState({
            remark: event.target.value,
        });
    };

    quickChange = (event) => {
        this.setState({
            quickString: event.target.value,
        });
    };

    pullmanNameChange = (event) => {
        this.setState({
            pullmanName: event.target.value,
        });
    };

    salesmanNameChange = (event) => {
        this.setState({
            salesmanName: event.target.value,
        });
    };

    /*业务归属渠道选中*/
    businessChannelChange = (value) => {
        this.setState({
            businessChannel: value,
        });
    };

    deliveryTimeonChange = (index, value) => {
        var submitRows = this.state.submitRows;
        submitRows[index].deliveryArrivalDate = value;
        this.setState({
            submitRows: submitRows
        });
    };

    changeRemark = (record, index, value) => {
        if (value.target.value.length > 100) {
            return;
        }
        var submitRows = this.state.submitRows;
        submitRows[index].remark = value.target.value;
        this.setState({
            submitRows: submitRows,
        });
    };

    onChangeInputNumber(record, index, value) {
        const self = this;
        var submitRows = this.state.submitRows;
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        if (value == "") {
            submitRows[index].count = 0;
        } else if (typeof value == 'string') {
            return;
        }
        if (!record.pickProAddress) {
            openNotice('warning', '请选择提货地点');
            submitRows[index].count = 0;
        } else {
            submitRows[index].count = value;
            if (self.props.params.id != 4) {
                var postList = {
                    channelCode: self.state.orderData.channelCode,
                    customerId: parseInt(self.state.orderData.thirdId),
                    purchaseId: self.state.detailData.id,
                    pickProAddress: self.state.submitRows[index].pickProAddress,
                    pickProAddressId: self.state.submitRows[index].pickProAddressId || self.state.submitRows[index].delvId,
                    proId: self.state.submitRows[index].productId,
                    count: self.state.submitRows[index].count || 0,
                    receiveAddressId: self.state.receiveAddressId,
                };
            } else {
                if (index < self.state.orderListData.length) {
                    var postList = {
                        channelCode: self.state.orderData.channelCode,
                        customerId: parseInt(self.state.orderData.thirdId),
                        purchaseId: self.state.detailData.id,
                        pickProAddress: self.state.submitRows[index].pickProAddress,
                        pickProAddressId: self.state.submitRows[index].pickProAddressId || self.state.submitRows[index].delvId,
                        proId: self.state.orderListData[index].productId,
                        count: self.state.submitRows[index].count || 0,
                        receiveAddressId: self.state.receiveAddressId,
                    };
                } else {
                    var postList = {
                        channelCode: self.state.orderData.channelCode,
                        customerId: parseInt(self.state.orderData.thirdId),
                        purchaseId: self.state.detailData.id,
                        pickProAddress: self.state.submitRows[index].pickProAddress || self.state.submitRows[index].delvId,
                        pickProAddressId: self.state.submitRows[index].pickProAddressId,
                        proId: self.state.submitRows[index].productId,
                        count: self.state.submitRows[index].count || 0,
                        receiveAddressId: self.state.receiveAddressId,
                    };
                }
            }
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var onhand = self.state.onhand;
                    var productionCycle = self.state.productionCycle;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    var cadreRepertory = self.state.cadreRepertory;
                    var reserveLineId = this.state.reserveLineId;
                    var reserveQuantity = this.state.reserveQuantity;
                    day[index] = res.data.day;
                    date[index] = res.data.date;
                    xiaFuJia[index] = res.data.xiaFuJia;
                    weiFaYunCount[index] = res.data.weiFaYunCount;
                    onhand[index] = res.data.onhand;
                    productionCycle[index] = res.data.productionCycle;
                    defDeliverDay[index] = res.data.defDeliverDay;
                    productName[index] = res.data.productName;
                    cadreRepertory[index] = res.data.cadreRepertory;
                    reserveLineId[index] = res.data.reserveLineId;
                    reserveQuantity[index] = res.data.reserveQuantity;
                    /*if (res.data.date == '待评审') {
                        submitRows[index].deliveryArrivalDate = null;
                    } else {
                        submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                    }*/
                    submitRows[index].date = res.data.date;
                    submitRows[index].cadreRepertory = res.data.cadreRepertory;
                    submitRows[index].onhand = res.data.onhand;
                    submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[index].productionCycle = res.data.productionCycle;
                    submitRows[index].day = res.data.day;
                    submitRows[index].xiaFuJia = res.data.xiaFuJia;
                    submitRows[index].priceRate = res.data.priceRate;
                    submitRows[index].showPrice = res.data.listPrice; //刷新面价
                    if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                        if (res.data.reserveLineId != "") {
                            if (res.data.reserveQuantity < submitRows[index].count) {
                                submitRows[index].reserveLid = null;
                            } else {
                                submitRows[index].reserveLid = res.data.reserveLineId;
                            }
                        }
                    }
                    self.setState({
                        day: day,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        onhand: onhand,
                        weiFaYunCount: weiFaYunCount,
                        productionCycle: productionCycle,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                        cadreRepertory: cadreRepertory,
                        reserveLineId: reserveLineId,
                        reserveQuantity: reserveQuantity,
                        submitRows: submitRows,
                    }, () => {
                        self.price();
                    });
                } else {
                    openNotice('warning', '数据获取失败，请确认实际收货地址、提货地点、开单数量是否正确');
                }
            });
        }
    }

    /*客户订单号填写*/
    customerOrderCodeChange = (event) => {
        this.setState({
            customerOrderCode: event.target.value,
        });
    };

    price() {
        var self = this;
        var price = 0;
        var allPrice = 0;
        var realyPrice = 0;
        var cutPrice = 0;
        var allRealyPrice = 0;
        var everyPrice = 0;
        var everyRealyPrice = 0;
        var everyCount = 0;
        for (var i = 0; i < self.state.submitRows.length; i++) {
            everyCount = self.state.submitRows[i].count || 0;
            everyPrice = self.state.submitRows[i].showPrice || 0;
            everyRealyPrice = self.state.submitRows[i].xiaFuJia || 0;
            allPrice = everyCount * everyPrice;
            price = price + allPrice;
            allRealyPrice = everyCount * everyRealyPrice;
            realyPrice = realyPrice + allRealyPrice;
            cutPrice = price - realyPrice;
        }
        var priceOfAll = price.toFixed(2);
        var priceOfRealy = realyPrice.toFixed(2);
        var priceOfCut = cutPrice.toFixed(2);
        self.setState({allPrice: priceOfAll, realyPrice: priceOfRealy, cutPrice: priceOfCut});
    }

    //离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    };

    componentWillMount() {
        const self = this;
        Notification.config({
            placement: 'topRight',
            top: 100,
            duration: 1,
        });
        window.myTemp = 1;
        var src = window.localStorage.getItem('server');
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
            passId: JSON.parse(localStorage.getItem('passId')),
            src: src,
        });
        if (self.props.params.id == 4) {
            var orderListData = this.state.orderListData;
            var submitRows = [...self.state.submitRows];
            for (var i = 0; i < orderListData.length; i++) {
                var x = {
                    itemNum: orderListData[i].productCode || orderListData[i].itemNum || '',
                    count: orderListData[i].count || '',
                    proLine: orderListData[i].proLine || '',
                    productionCycle: orderListData[i].productionCycle || '',
                    pickProAddress: self.state.tiAddress2 || '',
                    productName: orderListData[i].name || '',
                    productId: orderListData[i].productId || '',
                    showPrice: orderListData[i].price || orderListData[i].showPrice || '',
                    remark: orderListData[i].remark || '',
                    stockType: orderListData[i].stockType || '',
                    unit: orderListData[i].unit || '',
                    packageQuantity: orderListData[i].packageQuantity || '',
                    minPackageQuantity: orderListData[i].minPackageQuantity || '',
                    minPackageFlag: orderListData[i].minPackageFlag || '',
                    shoppingcartId: orderListData[i].id || '',
                    deliveryArrivalDate: orderListData[i].deliveryArrivalDate || '',
                    factory: orderListData[i].factory || '',
                    capacityControl: orderListData[i].capacityControl || '',
                    id: window.myTemp++,
                };
                submitRows.push(x);
            }
            self.setState({submitRows});
        }
        if (self.props.params.id == 5) {
            var dingPassParse = this.state.dingPassParse;
            var submitRows = [...self.state.submitRows];
            for (var i = 0; i < dingPassParse.length; i++) {
                var x = {
                    itemNum: dingPassParse[i].erpData.ITEM_NUM || '',
                    count: dingPassParse[i].count || '',
                    proLine: dingPassParse[i].proLine || '',
                    productionCycle: dingPassParse[i].productionCycle || '',
                    pickProAddress: self.state.tiAddress2 || '',
                    productName: dingPassParse[i].erpData.ITEM_DESC || '',
                    productId: dingPassParse[i].productId || '',
                    showPrice: dingPassParse[i].erpData.PRICE || '',
                    stockType: dingPassParse[i].stockType || '',
                    unit: dingPassParse[i].unit || '',
                    packageQuantity: dingPassParse[i].packageQuantity || '',
                    minPackageQuantity: dingPassParse[i].minPackageQuantity || '',
                    minPackageFlag: dingPassParse[i].minPackageFlag || '',
                    deliveryArrivalDate: dingPassParse[i].deliveryArrivalDate || '',
                    factory: dingPassParse[i].factory || '',
                    capacityControl: dingPassParse[i].capacityControl || '',
                    bookId: dingPassParse[i].bookId || '',
                    id: window.myTemp++,
                };
                submitRows.push(x);
            }
            self.setState({submitRows});
        }
        if (self.props.params.id == 6) {
            var passParse = this.state.passParse;
            var submitRows = [...self.state.submitRows];
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            for (var i = 0; i < passParse.length; i++) {
                var x = {
                    itemNum: passParse[i].proCode || '',
                    count: passParse[i].commitQuantity2 || '',
                    proLine: passParse[i].proLine || '',
                    productionCycle: passParse[i].productionCycle || '',
                    pickProAddress: passParse[i].orgName || '',
                    pickProAddressId: passParse[i].orgId || '',
                    delvId: passParse[i].orgId || '',
                    productName: passParse[i].proDesc || '',
                    productId: passParse[i].productId || '',
                    showPrice: passParse[i].showPrice || '',
                    remark: passParse[i].remark || '',
                    stockType: passParse[i].stockType || '',
                    unit: passParse[i].unit || '',
                    packageQuantity: passParse[i].packageQuantity || '',
                    minPackageQuantity: passParse[i].minPackageQuantity || '',
                    minPackageFlag: passParse[i].minPackageFlag || '',
                    deliveryArrivalDate: passParse[i].deliveryArrivalDate || '',
                    factory: passParse[i].factory || '',
                    capacityControl: passParse[i].capacityControl || '',
                    reserveLid: passParse[i].lineId || '',
                    id: window.myTemp++,
                };
                submitRows.push(x);
            }
            self.setState({submitRows});
            orderData.PurchaseUnit = passParse[0].buyCompanyName;
            orderData.channel = passParse[0].channel;
            orderData.thirdId = parseInt(passParse[0].cusId);
            orderData.channelCode = passParse[0].channelCode;
            orderData.cusId = parseInt(passParse[0].cusId);
            orderData.cusName = parseInt(passParse[0].cusId);
            detailData.cusName = passParse[0].customerName;
            detailData.status = passParse[0].status;
            detailData.id = parseInt(passParse[0].buyCompanyId);
            detailData.customerName = passParse[0].customerName;
            detailData.cusCode = passParse[0].customerCode;
            getGdList({
                customerId: parseInt(passParse[0].cusId),
                channelCode: passParse[0].channelCode,
                p: 1,
                s: 10,
                purchaseId: passParse[0].buyCompanyId,
            }).then(result => {
                if (result.status && result.data.length > 0) {
                    orderData.defDiscount = result.data[0].defDiscount;
                    orderData.sxeAmount = result.data[0].sxeAmount;
                } else {
                    message.error(result.message);
                }
            });
            self.setState({
                orderData,
                detailData,
                purchaseId: passParse[0].buyCompanyId,
                channelCode: passParse[0].channel,
                headerId: passParse[0].headerId,
                reserveHid: passParse[0].headerId,
                id6: true,
                remark: '预订单编号:' + passParse[0].headerId,
            });
        }
        /*从编辑进入详情*/
        if (self.props.params.id == 9) {
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            self.setState({
                usable: true,
            });
            /*获取订单详情*/
            getOrderDetails({id: self.props.params.orderId}).then(function (result) {
                    if (result && result.code == 200) {
                        var passParse = result.data.productList;
                        var passDetail = result.data;
                        orderData.PurchaseUnit = passDetail.buyCompany;
                        orderData.channel = passDetail.channel;
                        orderData.thirdId = parseInt(passDetail.cusId);
                        orderData.channelCode = passDetail.channelCode;
                        orderData.cusId = parseInt(passDetail.cusId);
                        orderData.cusName = parseInt(passDetail.cusId);
                        orderData.orderSource = passDetail.orderSource;
                        detailData.createdDate = passDetail.createdDate;
                        detailData.cusName = passDetail.customerName;
                        detailData.status = passDetail.status;
                        detailData.id = parseInt(passDetail.buyCompanyId);
                        detailData.customerName = passDetail.customerName;
                        detailData.cusCode = passDetail.customerCode;
                        orderData.defDiscount = passDetail.discountRate;
                        orderData.sxeAmount = passDetail.remainingSum;
                        orderData.salesmanName = passDetail.salesmanName;
                        orderData.pullmanName = passDetail.pullmanName;
                        orderData.orderSource = passDetail.orderSource;
                        orderData.sourceNo = passDetail.sourceNo;
                        orderData.businessChannel = passDetail.businessChannel;
                        if (passDetail.orderSubmit == false) {
                            orderData.orders = 1;
                            self.setState({orderSubmit3: 'none', orderSubmit2: 'block'});
                        } else {
                            orderData.orders = 0;
                            self.setState({orderSubmit3: 'block', orderSubmit2: 'none'});
                        }
                        if (passDetail.orderStatus == 1 && passDetail.getProCode != null) {
                            self.setState({orderSubmit4: 'block'});
                        }
                        self.setState({
                            orderData,
                            detailData,
                            purchaseId: passDetail.buyCompanyId,
                            channelCode: passDetail.channelCode,
                            deliveryShowprice: passDetail.deliveryShowprice,
                            id6: passDetail.reserveHid ? true : false,
                            status: passDetail.erpStatus,
                            sourceNo: passDetail.sourceNo,
                            postCount: 0,
                        });
                        self.setState({
                            usable: true,
                        });
                        var submitRows = [...self.state.submitRows];
                        for (let i = 0; i < passParse.length; i++) {
                            if (passParse[i].orderProductPartList) {
                                // var a = 0 ;
                                for (let j = 0; j < passParse[i].orderProductPartList.length; j++) {
                                    passParse[i].orderProductPartList[j].appointDeliveryDate = moment(passParse[i].orderProductPartList[j].appointDeliveryDate);
                                }
                            }
                            var x = {
                                itemNum: passParse[i].productCode || '',
                                count: passParse[i].count || '',
                                proLine: passParse[i].proLine || '',
                                lineId: passParse[i].lineId || '',
                                reserveLid: passParse[i].reserveLid || '',
                                productionCycle: passParse[i].productionCycle || '',
                                pickProAddress: passParse[i].pickProAddress || '',
                                pickProAddressId: parseInt(passParse[i].delvId) || '',
                                delvId: parseInt(passParse[i].delvId) || '',
                                productName: passParse[i].productName || '',
                                productId: passParse[i].productId || '',
                                showPrice: passParse[i].originalPrice || '',
                                remark: passParse[i].remark || '',
                                stockType: passParse[i].stockType || '',
                                unit: passParse[i].unit || '',
                                packageQuantity: passParse[i].packageQuantity || '',
                                minPackageQuantity: passParse[i].minPackageQuantity || '',
                                minPackageFlag: passParse[i].minPackageFlag || '',
                                orderProductPartList: passParse[i].orderProductPartList || '',
                                id: window.myTemp++,
                                faYunCount: passParse[i].faYunCount || '',
                                weiFaYunCount: passParse[i].weiFaYunCount || '',
                                deliveryArrivalDate: passParse[i].deliveryArrivalDate || '',
                                factory: passParse[i].factory || '',
                                capacityControl: passParse[i].capacityControl || '',
                                secondStockType: passParse[i].secondStockType || '',
                                noshowOnhand: passParse[i].noshowOnhand || '',
                            };
                            if (!passParse[i].delvId) {
                                x.delvId = parseInt(passParse[i].pickProAddressId) || '';
                            }
                            submitRows.push(x);

                            self.setState({
                                submitRows: submitRows,
                                remark: passDetail.remark,
                                customerOrderCode: passDetail.customerOrderCode,
                                seller: passDetail.salesmanName,
                                recipientName: passDetail.contacts,
                                mobile: passDetail.phone,
                                id: passDetail.id,
                                gatherRealityAddress: passDetail.gatherRealityAddress.toString(),
                                gatherRealityAddress1: passDetail.gatherRealityAddress.toString(),
                                gatherRealityAddress2: passDetail.gatherAddressId.toString(),
                                projectId: passDetail.projectId,
                                allPrice: passDetail.amount,
                                createdBy: passDetail.createdBy,
                                realyPrice: passDetail.realityAmount,
                                cutPrice: (passDetail.amount - passDetail.realityAmount).toFixed(6),
                                getProCode: passDetail.getProCode || '',
                                giveBackStatus: passDetail.orderStatus || 0,
                                reserveHid: passDetail.reserveHid || '',
                                headerId2: passDetail.headerId,
                                receiveAddressId: passDetail.gatherAddressId || '',
                                salesmanName: passDetail.salesmanName,
                                pullmanName: passDetail.pullmanName,
                                orderSource: passDetail.orderSource,
                                businessChannel: passDetail.businessChannel,
                                apiFlag: passDetail.orderSource ? true : false,
                            }, () => {
                                if (self.props.params.id == 9) {
                                    if (self.props.params.type && self.props.params.type == '再来一单') {
                                        var state = {...self.state};
                                        delete self.state.getProCode;
                                        delete self.state.orderData.orderSource;
                                        delete self.state.orderData.sourceNo;
                                        delete self.state.apiFlag;
                                        delete self.state.receiveAddressId;
                                        delete self.state.gatherRealityAddress;
                                        delete self.state.gatherRealityAddress2;
                                        submitRows.map(item => {
                                            delete item.deliveryArrivalDate;
                                            delete item.reserveLid;
                                        })
                                        self.setState({state: state, orderSource: null, sourceNo: null, submitRows});
                                        getGdList({
                                            customerId: passDetail.cusId,
                                            channelCode: passDetail.channelCode,
                                            p: 1,
                                            s: 10,
                                            purchaseId: parseInt(passDetail.buyCompanyId),
                                        }).then(result => {
                                            if (result.status && result.data.length > 0) {
                                                self.state.orderData.defDiscount = result.data[0].defDiscount;
                                                self.state.orderData.sxeAmount = result.data[0].sxeAmount;
                                                self.setState({state: state, orderSource: null});
                                            } else {
                                                message.error(result.message);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                        self.setState({submitRows}, () => {
                            self.initData();
                            self.refreshList();
                        });
                    }
                },
            );
        }
    }
    ;

    componentDidMount() {
        const self = this;
        if (self.props.params.id != 9) {
            self.initData();
            self.setState({apiFlag: false});
        }
        if (self.state.orderData.orders == 1) {
            self.setState({orderSubmit3: 'none', orderSubmit2: 'block'});
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        window.addProduct = (record) => {
            self.setState({visible: false})
            self.addSave(record)
        };
        window.toggleShowBackBtn = this.toggleShowBackBtn;
    }

    componentWillUnmount() {
        window.addProduct = null;
        window.toggleShowBackBtn = null;
    }

    toggleShowBackBtn = (flag) => {
        this.setState({showBackBtn: flag})
    }
    handleOk = () => {
        this.setState({visible: false});
    };

    handleOk2 = (value, record, index) => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    };

    handleCancel = () => {
        this.setState({visible: false});
    };

    handleCancel2 = () => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    };

    handleCancel6 = () => {
        this.setState({quickVisible: false});
    };

    refreshList = () => {
        this.setState({
            usable: true,
        });
        var postCount = 0;
        var finishCount = 0;
        var submitRows = this.state.submitRows;
        submitRows.forEach(() => {
            postCount++;
        });

        this.setState({
            postCount: postCount
        });


        submitRows.forEach((row, index) => {
            setTimeout(() => {
                var postList = {
                    channelCode: this.state.orderData.channelCode,
                    customerId: parseInt(this.state.orderData.thirdId),
                    purchaseId: this.state.detailData.id,
                    pickProAddress: this.state.submitRows[index].pickProAddress,
                    pickProAddressId: this.state.submitRows[index].delvId,
                    proId: this.state.submitRows[index].productId,
                    count: this.state.submitRows[index].count || 0,
                    receiveAddressId: this.state.receiveAddressId,
                };
                getDongList(postList).then(res => {
                    if (res.code == 200 && res.data) {
                        finishCount++
                        this.setState({
                            finishCount: finishCount,
                        });
                        if (postCount == finishCount) {
                            this.setState({
                                usable: false,
                            });
                        }
                        var day = this.state.day;
                        var date = this.state.date;
                        var xiaFuJia = this.state.xiaFuJia;
                        var weiFaYunCount = this.state.weiFaYunCount;
                        var onhand = this.state.onhand;
                        var productionCycle = this.state.productionCycle;
                        var defDeliverDay = this.state.defDeliverDay;
                        var productName = this.state.productName;
                        var cadreRepertory = this.state.cadreRepertory;
                        var reserveLineId = this.state.reserveLineId;
                        var reserveQuantity = this.state.reserveQuantity;
                        day[index] = res.data.day;
                        date[index] = res.data.date;
                        xiaFuJia[index] = res.data.xiaFuJia;
                        weiFaYunCount[index] = res.data.weiFaYunCount;
                        onhand[index] = res.data.onhand;
                        productionCycle[index] = res.data.productionCycle;
                        defDeliverDay[index] = res.data.defDeliverDay;
                        productName[index] = res.data.productName;
                        cadreRepertory[index] = res.data.cadreRepertory;
                        reserveLineId[index] = res.data.reserveLineId;
                        reserveQuantity[index] = res.data.reserveQuantity;
                        /*if (res.data.date == '待评审') {
                            submitRows[index].deliveryArrivalDate = null;
                        } else {
                            submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                        }*/
                        submitRows[index].date = res.data.date;
                        submitRows[index].cadreRepertory = res.data.cadreRepertory;
                        submitRows[index].onhand = res.data.onhand;
                        submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                        submitRows[index].productionCycle = res.data.productionCycle;
                        submitRows[index].day = res.data.day;
                        submitRows[index].priceRate = res.data.priceRate;
                        submitRows[index].xiaFuJia = res.data.xiaFuJia;
                        submitRows[index].showPrice = res.data.listPrice; //刷新面价
                        if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                            if (res.data.reserveLineId != "") {
                                if (res.data.reserveQuantity < submitRows[index].count) {
                                    submitRows[index].reserveLid = null;
                                } else {
                                    submitRows[index].reserveLid = res.data.reserveLineId;
                                }
                            }
                        }
                        this.setState({
                            day: day,
                            date: date,
                            xiaFuJia: xiaFuJia,
                            onhand: onhand,
                            weiFaYunCount: weiFaYunCount,
                            productionCycle: productionCycle,
                            defDeliverDay: defDeliverDay,
                            productName: productName,
                            cadreRepertory: cadreRepertory,
                            reserveLineId: reserveLineId,
                            reserveQuantity: reserveQuantity,
                            submitRows: submitRows,
                        }, () => {
                            this.price();
                        });
                    } else {
                        console.log(res);
                    }
                })
            }, (index + 1) * 1000);
        });

    };

    handleOk6 = () => {
        if (this.state.quickString.length == 0) {
            this.setState({quickVisible: false, quickLoading: false, quickString: ''});
            return;
        }
        var rowcount = 0;
        var finshcount = 0;
        this.setState({quickLoading: true, quickResult: []});
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                rowcount++;
            }
        });
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                var searchItem;
                var count = null;
                if (item.trim().indexOf(',') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(','));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(',') + 1))) {
                        count = item.trim().substr(item.trim().indexOf(',') + 1);
                    }
                } else if (item.trim().indexOf(' ') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(' ') + 1))) {
                        count = item.trim().substr(item.trim().indexOf(' ') + 1);
                    }
                } else if (item.trim().indexOf('\t') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf('\t') + 1))) {
                        count = item.trim().substr(item.trim().indexOf('\t') + 1);
                    }
                } else {
                    searchItem = item.trim();
                }
                getPro({
                    channelCode: this.state.orderData.channelCode,
                    customerId: this.state.orderData.thirdId,
                    name: searchItem,
                    stockType: this.state.stockType,
                    p: 1,
                    s: 1,
                }).then(result => {
                    finshcount++;
                    if (result.status && result.code == 200) {
                        if (result.total > 0) {
                            if (result.data[0].itemManagerFlag == 'Y' && result.data[0].orderManagerFlag == 'Y') {
                                result.data[0].count = count;
                                const quickResult = this.state.quickResult;
                                quickResult.push(result.data[0]);
                            }
                        }
                    } else {
                        message.error(result.message);
                        this.setState({quickLoading: false});
                    }
                    if (rowcount == finshcount) {

                        this.state.quickString.split(/[\n]/).forEach(item => {
                            if (item.trim().length > 0) {
                                const quickResult = this.state.quickResult;
                                quickResult.forEach(item2 => {
                                    var searchItem;
                                    if (item.trim().indexOf(',') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(','));
                                    } else if (item.trim().indexOf(' ') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                                    } else if (item.trim().indexOf('\t') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                                    } else {
                                        searchItem = item.trim();
                                    }
                                    if (item2.itemNum == searchItem) {
                                        this.addSave(item2, null, null);
                                    }
                                })
                            }
                        });

                        this.refreshList();
                        this.setState({quickVisible: false, quickLoading: false, quickString: '', quickResult: []});
                    }
                });
            }
        });
    };

    /*智能录入弹窗*/
    quickHandler = (event) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return;
        }
        if (!this.state.orgId || this.state.orgId == '') {
            openNotice('warning', '请先选择提货地点');
            return;
        }
        this.setState({quickVisible: true});
    };

    addFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    };

    deleteFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    };

    handleChange = (index, value) => {
        var dataSource2 = [...this.state.dataSource2];
        dataSource2[index].appointDeliveryDate = value;
        this.setState({dataSource2: dataSource2});
    };

    onOkData = (text, record, value) => {
        console.log('onOk: ', value);
    };

    handleAdd2 = () => {
        const {count2, dataSource2, number2} = this.state;
        const newData2 = {
            key: count2,
            startCount: '',
            endCount: '',
            discountCategory: '',
            discount: '',
            removeFlag2: 0,
            number2: number2,
        };
        this.setState({
            dataSource2: [...dataSource2, newData2],
            count2: count2 + 1,
            number2: number2 + 1,
        });
    };

    onCellChange2 = (record, index, value) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2[index].deliveryCount = value.target.value;
        this.setState({dataSource2: dataSource2});
    };

    onDelete2 = (key) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2.splice(key, 1);
        for (var i = 0; i < dataSource2.length; i++) {
            if (dataSource2[i] == '' || typeof (dataSource2[i]) == 'undefined') {
                dataSource2.splice(i, 1);
                i = i - 1;
            }
        }
        this.setState({dataSource2: dataSource2});
    };

    saveFenPi = (record, index, value) => {
        var submitRows = [...this.state.submitRows];
        var dataSource2 = [...this.state.dataSource2];
        var dataSource3 = parseInt(this.state.dataSource3);
        submitRows[dataSource3].orderProductPartList = dataSource2;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            if (this.state.submitRows[i].orderProductPartList && this.state.submitRows[i].orderProductPartList.length > 0) {
                for (let j = 0; j < this.state.submitRows[i].orderProductPartList.length; j++) {
                    this.state.submitRows[i].orderProductPartList[j].logisticsCycle = this.state.defDeliverDay[i];
                    this.state.submitRows[i].orderProductPartList[j].productName = this.state.productName2[i];
                    delete this.state.submitRows[i].orderProductPartList[j].key;
                    delete this.state.submitRows[i].orderProductPartList[j].startCount;
                    delete this.state.submitRows[i].orderProductPartList[j].endCount;
                    delete this.state.submitRows[i].orderProductPartList[j].discountCategory;
                    delete this.state.submitRows[i].orderProductPartList[j].discount;
                    delete this.state.submitRows[i].orderProductPartList[j].removeFlag2;
                    delete this.state.submitRows[i].orderProductPartList[j].number2;
                }
            }
        }
        var x = 0;
        var y = 0;
        var date = new Date();
        var date2 = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
        for (var k = 0; k < dataSource2.length; k++) {
            x = x + parseInt(dataSource2[k].deliveryCount);
            if (!dataSource2[k].appointDeliveryDate || dataSource2[k].appointDeliveryDate < date || dataSource2[k].appointDeliveryDate > date2) {
                y = 1;
            }
        }
        submitRows[dataSource3].faYunCount = x;
        if (x != submitRows[dataSource3].count) {
            openNotice('warning', '请确认发货数量');
        } else if (y == 1) {
            openNotice('warning', '请确认发货日期');
        } else {
            this.setState({submitRows: submitRows});
            this.setState({dataSource2: []});
            this.setState({modalVisible: false});
        }
    };

    resetView = () => {
        window.location.reload();
    };

    piLiang = (value) => {
        const self = this;
        var submitRows = [...self.state.submitRows];
        let messages2 = this.state.tiAddress.filter(x => x.id == value)[0];
        var orgId = value;
        var orgName = messages2.delvName;
        self.setState({defaultAddress: orgId, usable: true});
        for (let record = 0; record < submitRows.length; record++) {
            submitRows[record].pickProAddress = orgName;
            submitRows[record].delvId = orgId;
        }
        self.setState({orgId: orgId, orgName: orgName, submitRows: submitRows}, () => {
            this.refreshList();
        });
    };

    deleteHandler = () => {
        const self = this;
        if (this.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请确认删除的商品');
            return;
        }
        var selectedRowKeys = this.state.selectedRowKeysOutside;
        self.setState({
            ...self.state,
            selectedRowKeys: [],
            submitRows: self.state.submitRows.filter(x => selectedRowKeys.indexOf(x.id) === -1),
        }, () => {
            self.price();
        });
        for (let i = 0; i < selectedRowKeys.length; i++) {
            var day = self.state.day;
            var date = self.state.date;
            var xiaFuJia = self.state.xiaFuJia;
            var weiFaYunCount = self.state.weiFaYunCount;
            var onhand = self.state.onhand;
            var cadreRepertory = self.state.cadreRepertory;
            var productionCycle = self.state.productionCycle;
            var defDeliverDay = self.state.defDeliverDay;
            var productName = self.state.productName;
            var reserveLineId = self.state.reserveLineId;
            var reserveQuantity = self.state.reserveQuantity;
            day.splice([selectedRowKeys[i] - 1], 1);
            date.splice([selectedRowKeys[i] - 1], 1);
            xiaFuJia.splice([selectedRowKeys[i] - 1], 1);
            weiFaYunCount.splice([selectedRowKeys[i] - 1], 1);
            cadreRepertory.splice([selectedRowKeys[i] - 1], 1);
            onhand.splice([selectedRowKeys[i] - 1], 1);
            productionCycle.splice([selectedRowKeys[i] - 1], 1);
            defDeliverDay.splice([selectedRowKeys[i] - 1], 1);
            productName.splice([selectedRowKeys[i] - 1], 1);
            reserveLineId.splice([selectedRowKeys[i] - 1], 1);
            reserveQuantity.splice([selectedRowKeys[i] - 1], 1);
            self.setState({
                day: day,
                date: date,
                xiaFuJia: xiaFuJia,
                weiFaYunCount: weiFaYunCount,
                onhand: onhand,
                cadreRepertory: cadreRepertory,
                productionCycle: productionCycle,
                defDeliverDay: defDeliverDay,
                productName: productName,
                reserveLineId: reserveLineId,
                reserveQuantity: reserveQuantity
            });
        }
    };

    refresh() {
        const self = this;
        var submitRows = [...self.state.submitRows];
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        self.setState({
            day: [],
            date: [],
            xiaFuJia: [],
            onhand: [],
            weiFaYunCount: [],
            defDeliverDay: [],
            productionCycle: [],
            productName: [],
            cadreRepertory: [],
            reserveLineId: [],
            reserveQuantity: []
        });
        for (let t = 0; t < self.state.submitRows.length; t++) {
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: self.state.orderData.thirdId,
                purchaseId: self.state.detailData.id,
                pickProAddress: submitRows[t].pickProAddress || '',
                pickProAddressId: parseInt(submitRows[t].delvId) || '',
                proId: submitRows[t].productId,
                count: submitRows[t].count || 0,
                receiveAddressId: self.state.receiveAddressId,
            };
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var onhand = self.state.onhand;
                    var productionCycle = self.state.productionCycle;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    var cadreRepertory = self.state.cadreRepertory;
                    var reserveLineId = this.state.reserveLineId;
                    var reserveQuantity = this.state.reserveQuantity;
                    day[t] = res.data.day;
                    date[t] = res.data.date;
                    xiaFuJia[t] = res.data.xiaFuJia;
                    weiFaYunCount[t] = res.data.weiFaYunCount;
                    onhand[t] = res.data.onhand;
                    productionCycle[t] = res.data.productionCycle;
                    defDeliverDay[t] = res.data.defDeliverDay;
                    productName[t] = res.data.productName;
                    cadreRepertory[t] = res.data.cadreRepertory;
                    reserveLineId[t] = res.data.reserveLineId;
                    reserveQuantity[t] = res.data.reserveQuantity;
                    /*if (res.data.date == '待评审') {
                        submitRows[t].deliveryArrivalDate = null;
                    } else {
                        submitRows[t].deliveryArrivalDate = submitRows[t].deliveryArrivalDate && submitRows[t].capacityControl == 1 ? submitRows[t].deliveryArrivalDate : res.data.date;
                    }*/
                    submitRows[t].date = res.data.date;
                    submitRows[t].cadreRepertory = res.data.cadreRepertory;
                    submitRows[t].onhand = res.data.onhand;
                    submitRows[t].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[t].productionCycle = res.data.productionCycle;
                    submitRows[t].day = res.data.day;
                    submitRows[t].xiaFuJia = res.data.xiaFuJia;
                    submitRows[t].priceRate = res.data.priceRate;
                    submitRows[t].showPrice = res.data.listPrice; //刷新面价
                    if (submitRows[t].reserveLid == null || submitRows[t].reserveLid == "") {
                        if (res.data.reserveLineId != "") {
                            if (res.data.reserveQuantity < submitRows[t].count) {
                                submitRows[t].reserveLid = null;
                            } else {
                                submitRows[t].reserveLid = res.data.reserveLineId;
                            }
                        }
                    }
                    self.setState({
                        day: day,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        onhand: onhand,
                        weiFaYunCount: weiFaYunCount,
                        defDeliverDay: defDeliverDay,
                        productionCycle: productionCycle,
                        productName: productName,
                        cadreRepertory: cadreRepertory,
                        reserveLineId: reserveLineId,
                        reserveQuantity: reserveQuantity
                    }, () => {
                        self.price();
                    });
                }
            });
        }
    }

    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    };

    handleCancel3 = () => {
        this.setState({
            confirmvisible: false,
            confirmLoading: false,
        });
    };

    importLineData(res) {
        const self = this;
        var passParse = res.data;
        if (res.msg && res.msg != '' && res.msg != 'null') {
            message.warning(res.msg);
        }
        if (res.data == null) {
            message.warning('导入失败');
            return;
        }
        var submitRows = [...self.state.submitRows];
        for (let T = 0; T < passParse.length; T++) {
            var x = {
                itemNum: passParse[T].productCode || '',
                count: passParse[T].count || '',
                proLine: passParse[T].proLine || '',
                lineId: passParse[T].lineId || '',
                // productionCycle :  passParse[T].productionCycle || '',
                pickProAddress: passParse[T].pickProAddress || '',
                pickProAddressId: parseInt(passParse[T].delvId) || '',
                delvId: parseInt(passParse[T].delvId) || '',
                productName: passParse[T].productName || '',
                productId: passParse[T].productId || '',
                showPrice: passParse[T].originalPrice || '',
                remark: passParse[T].remark || '',
                stockType: passParse[T].stockType || '',
                unit: passParse[T].unit || '',
                packageQuantity: passParse[T].packageQuantity || '',
                minPackageQuantity: passParse[T].minPackageQuantity || '',
                minPackageFlag: passParse[T].minPackageFlag || '',
                reserveLid: passParse[T].reserveLid || '',
                id: window.myTemp++,
            };
            submitRows.push(x);
            self.setState({submitRows});
        }
        self.refresh();
    }

    render() {
        var self = this;
        var lines = '例如生产周期为[1,3]表示：类型为库存类的产品，有库存时生产需要1天，无库存时生产需要3天。\n' +
            '类型为非库存类的产品，显示为准确的生产天数';
        const {
            shouHuoShow,
            opts,
            key,
            total,
            searchObj,
            selectedRowKeysOutside,
            visible,
            addRows,
            addTotal,
            addSearchObj,
            orderData,
            detailData,
            optionAddress,
            optionTerminal,
            remark,
            customerOrderCode,
            button_limits_end,
            mobile,
            recipientName,
            tiAddress,
            xinzengShow,
            allPrice,
            realyPrice,
            dataSource2,
            dataSource3,
            gatherRealityAddress2,
            terminalMessage,
            defaultAddress,
            loading,
            id6,
            orderSubmit3,
            orderSubmit2,
            orderSubmit4,
            confirmLoading,
            confirmvisible,
            salesmanName,
            quickVisible,
            quickString,
            quickLoading,
            orgId,
            cascaderValue,
            tree,
            ts_disabled,
            ts_checked,
            ls_checked,
            apiFlag,
            activeKey,
            showBackBtn,
            minPackageFlag,
            finishCount,
            postCount
        } = this.state;
        const disabledDate = (current) => {
            return current && current.valueOf() < Date.now() || current && current.valueOf() > (Date.now() + 30 * 24 * 60 * 60 * 1000);
        };
        let uploadParam = toImportExcel1(
            1,
            self.state.orderData.channelCode,
            parseInt(self.state.orderData.thirdId),
            self.state.detailData.id,
            self.state.receiveAddressId,
            '',
            '',
            (result) => {
                this.importLineData(result);
            },
        );
        const fenPiFaYun = {
            size: 'small',
            pagination: false,
            bordered: true,
            dataSource: dataSource2,
            columns: [
                {
                    title: '约定发货日期',
                    dataIndex: 'appointDeliveryDate',
                    render: (text, record, index) => {
                        return (<DatePicker
                            showTime
                            value={text}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD"
                            placeholder="选择时间"
                            onChange={this.handleChange.bind(this, index)}
                        />);
                    },
                },
                {
                    title: '默认发货周期（天）',
                    dataIndex: 'logisticsCycle',
                    render: (text, record, index) => {
                        return <span>{this.state.defDeliverDay[dataSource3] || 0}</span>;
                    },
                },
                {
                    title: '发货数量',
                    dataIndex: 'deliveryCount',
                    render: (text, record, index) => {
                        return (<span><Input
                            defaultValue={text}
                            onChange={this.onCellChange2.bind(this, record, index)}
                        /></span>);
                    },
                },
                {
                    title: '物料名称',
                    dataIndex: 'productName',
                    render: (text, record, index) => {
                        return <span style={{whiteSpace: 'pre'}}>{this.state.productName2 || 0}</span>;
                    },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '200',
                    render: (text, record, index) => {
                        const {dataSource2} = this.state;
                        return (
                            dataSource2.length > 0 ?
                                (
                                    <a onClick={() => this.onDelete2(index)}>删除</a>
                                ) : null
                        );
                    },
                },
            ],
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            scroll: {x: 2000, y: false},
            columns: [
                {
                    title: '序号',
                    width: 50,
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return index + 1;
                    },
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    width: 70,
                    render: (text) => {
                        switch (text) {
                            case '01' || '元器件':
                                return <span>{'元器件'}</span>;
                                break;
                            case '02' || '电工':
                                return <span>{'电工'}</span>;
                                break;
                            case '03' || '电表':
                                return <span>{'电表'}</span>;
                                break;
                            case '04' || '变频器':
                                return <span>{'变频器'}</span>;
                                break;
                            case '05' || '天e':
                                return <span>{'天e'}</span>;
                                break;
                            case '06' || 'TG精品':
                                return <span>{'TG精品'}</span>;
                                break;
                        }
                    },
                },
                {
                    title: '物料编码',
                    width: 120,
                    dataIndex: 'itemNum',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {(record.capacityControl == 1 && (record.date == "待评审" || (record.date != "待评审" && moment(record.deliveryArrivalDate ? record.deliveryArrivalDate : record.date) < moment(record.date)))) ?
                                    <Tag color="orange"
                                         style={{float: 'right', cursor: 'default'}}>产能预警</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '物料描述',
                    width: 210,
                    dataIndex: 'productName',
                },
                {
                    title: '库存属性',
                    width: 90,
                    dataIndex: 'stockType',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {record.stockType == '定制' ?
                                    <Tag color="green"
                                         style={{float: 'right', cursor: 'default'}}>定制开单</Tag> : null}
                                {(record.stockType == '库存' && record.secondStockType != null) ?
                                    <Tag color="green"
                                         style={{
                                             float: 'right',
                                             cursor: 'default'
                                         }}>{record.secondStockType}</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '牌价',
                    width: 70,
                    dataIndex: 'showPrice',
                },
                {
                    title: '下浮价',
                    dataIndex: 'xiaFuJia',
                    width: 70,
                    render: (text, record, index) => {
                        /*if (!xiaFuJia[index]) {
                            return (<span>{'0'}</span>);
                        } else {
                            return (<span>{xiaFuJia[index]}</span>);
                        }*/
                        return (<span>{text || '0'}</span>);
                    },
                },
                {
                    title: '下浮率',
                    width: 50,
                    dataIndex: 'priceRate',
                },
                {
                    title: '单位',
                    width: 50,
                    dataIndex: 'unit',
                },
                {
                    title: '参考库存',
                    width: 100,
                    dataIndex: 'onhand',
                    render: (text, record, index) => {
                        return (
                            <Tooltip
                                title="提货地点库存/总部库存"><span>{record.noshowOnhand ? '*' : text}/{record.noshowOnhand ? '*' : record.cadreRepertory}</span></Tooltip>
                        );
                    },
                },
                {
                    title: '未发数量',
                    dataIndex: 'weiFaYunCount',
                    width: 90,
                    render: (text, record, index) => {
                        /*if (!weiFaYunCount[index]) {
                            return (<span>{'0'}</span>);
                        } else {
                            return (<span>{weiFaYunCount[index]}</span>);
                        }*/
                        return (<span>{text || '0'}</span>);
                    },
                },
                {
                    title: '开单数量',
                    width: 100,
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return (<div><Tooltip
                            visible={record.minPackageFlag === 'Y' && record.minPackageQuantity && minPackageFlag === 'Y' && text % record.minPackageQuantity != 0}
                            title={"请按内盒凑整数" + record.minPackageQuantity + "的倍数填写数量"}
                            getPopupContainer={triggerNode => triggerNode.parentElement}></Tooltip>
                            <InputNumber value={self.state.submitRows[index].count || 0} min={0} defaultValue={0}
                                         disabled={apiFlag}
                                         style={{borderColor: record.minPackageFlag === 'Y' && record.minPackageQuantity && minPackageFlag === 'Y' && text % record.minPackageQuantity != 0 ? 'red' : '#d9d9d9'}}
                                         step={record.minPackageFlag === 'Y' && record.minPackageQuantity && minPackageFlag === 'Y' ? record.minPackageQuantity : 1}
                                         onChange={this.onChangeInputNumber.bind(this, record, index)} /*disabled={this.state.reserveHid && this.state.reserveHid != '' ? true : false}*/ />
                        </div>);
                    },
                },
                {
                    title: '装箱数',
                    width: 70,
                    dataIndex: 'packageQuantity',
                },
                {
                    title: <Tooltip title='产品内盒凑整数，请按照倍数订货'>内盒凑整数</Tooltip>,
                    width: 105,
                    dataIndex: 'minPackageQuantity',
                    render: (text, record, index) => {
                        if (record.minPackageFlag === 'Y') {
                            return <span>{text}</span>
                        } else {
                            return <span>-</span>
                        }
                    }
                },
                {
                    title: <Tooltip title={lines}>生产周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'productionCycle',
                    render: (text, record, index) => {
                        /*if (productionCycle.toString().includes('[')) {
                            return <Tooltip title="有库存天数/无库存天数">{productionCycle[index]}</Tooltip>;
                        } else {
                            return (<span>{productionCycle[index]}</span>);
                        }*/
                        if (text != null && text.includes('[')) {
                            return <Tooltip title="有库存天数/无库存天数">{text}</Tooltip>;
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: <Tooltip title="例：物流周期：[2,6]代表：有库存物流发货:2天，无库存:6天">物流周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'day',
                    render: (text, record, index) => {
                        /*if (day.toString().includes('[')) {
                            return <Tooltip title="有库存天数/无库存天数">{day[index]}</Tooltip>;
                        }
                        return (<span>{day[index]}</span>);*/

                        if (text != null && text.includes('[')) {
                            return <Tooltip title="有库存天数/无库存天数">{text}</Tooltip>;
                        }
                        return (<span>{text}</span>);
                    },
                },
                {
                    title: '参考到货期',
                    width: 105,
                    dataIndex: 'date',
                    render: (text, record, index) => {
                        if (typeof text == 'string') {
                            return text;
                        } else if (!text) {
                            return (<span>{text || '0'}</span>);
                        }
                    },
                },
                {
                    title: '预计到货期',
                    width: 105,
                    dataIndex: 'predictArrivalDate',
                    render: text => {
                        if (typeof text == 'string') {
                            return text;
                        } else {
                            text ? new Date(text).format('yyyy-MM-dd') : '';
                        }
                    },
                },
                {
                    title: '要求交期',
                    width: 125,
                    dataIndex: 'deliveryArrivalDate',
                    render: (text, record, index) =>
                        <Tooltip title="启用产能控制的产品可修改交期">
                            <div>
                                <DatePicker onChange={self.deliveryTimeonChange.bind(this, index)}
                                            format="YYYY-MM-DD"
                                            value={text ? moment(text) : null}
                                            disabled={xinzengShow || record.capacityControl != 1}/>
                            </div>
                        </Tooltip>
                },
                {
                    title: '备注',
                    width: 150,
                    dataIndex: 'remark',
                    render: (text, record, index) => <div><Input defaultValue={text}
                                                                 maxLength="100"
                                                                 value={text}
                                                                 onChange={self.changeRemark.bind(this, record, index)}
                                                                 disabled={apiFlag || xinzengShow}/></div>
                },
                {
                    title: '提货地点',
                    width: 150,
                    dataIndex: 'pickProAddress',
                    render: (text, record, index) => {
                        return <Select
                            style={{width: 150}}
                            value={this.state.submitRows[index].pickProAddress}
                            onSelect={this.addressChange2.bind(this)}
                            disabled={xinzengShow || id6 || apiFlag}
                        >
                            {(tiAddress || '').map(function (ele, itm, record) {
                                return <Option key={itm} recordIndex={index}
                                               value={ele.id + ''}>{ele.delvName}</Option>;
                            })}
                        </Select>;
                    },
                },
                /*{
                    title: <Tooltip title='该功能用于产品分批发货，可自定义每一批产品的发货时间'>分批发运</Tooltip>,
                    dataIndex: 'orderProductPartList',
                    width: 85,
                    render: (text, record, index) => {
                        return (<div>
                            <img src={fenPi} alt='' title='分批发运' onClick={this.openModal.bind(this, record, index)}
                                 style={{width: '20px'}}/>
                            <Modal
                                visible={modalVisible}
                                title="分批发运"
                                onCancel={this.handleCancel2}
                                maskClosable={false}
                                width={1000}
                                style={{top: 20}}
                                footer={null}
                            >
                                <div>
                                    <Button onClick={this.handleAdd2}>添加行</Button>
                                    <Button onClick={this.saveFenPi.bind(this, record, index)}
                                            style={{marginLeft: 10}}>确认添加</Button>
                                    <Table {...fenPiFaYun} bordered style={{marginTop: 10}}/>
                                </div>
                            </Modal>
                        </div>);
                    },
                },*/
            ],
            rows: this.state.submitRows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: self.onOutsideSelectChange},
        };
        const addProps = {
            rowKey: 'id',
            loading: loading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange,
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 90,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 220,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    width: 60,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null || record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span style={{color: '#d61518', height: 50}}>{'¥' + text}</span>);
                        }
                    },
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType',
                    width: 60,
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    width: 220,
                    render: (text, record, index) => {
                        return <span>{`${record.proBigName}/${record.proMiddleName}/${record.proDetailName}`}</span>;
                    },
                },
                // {
                //     title: '产能',
                //     dataIndex: 'capacityStatus',
                //     width: 40,
                //     render: (text, record, index) => {
                //         let a;
                //         switch (text) {
                //             case "0":
                //                 a = <span>🩶</span>;
                //                 break;
                //             case "1":
                //                 a = <span>💚</span>;
                //                 break;
                //             case "2":
                //                 a = <span>💛</span>;
                //                 break;
                //             case "3":
                //                 a = <span>❤️</span>;
                //                 break;
                //             default:
                //                 a = <span>🩶</span>;
                //                 break;
                //         }
                //         return <Tooltip placement="topLeft" title="💚正常;💛紧张;❤️严重不足;🩶无法获取"> {a} </Tooltip>
                //     },
                // },
                {
                    title: '历史开单量',
                    dataIndex: 'historyCount',
                    width: 70,
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>无开单权限，请联系【价格管理部】申请开通下单权限</span>);
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (
                                <span>经公司高层领导决定，对专属定制物料进行全面管控，若有需求，请发起定制申请</span>);
                        } else {
                            return (<Button style={{background: '#red'}} icon="plus"
                                            onClick={this.addSave.bind(this, record, index)}>添加</Button>);
                        }
                    },
                },
            ],
            rows: addRows,
        };
        const merchandiseUrl = `${location.href.split('#')[0]}#/mallSelect`
        var orderCategory;
        if (orderData.Type == 'Y1') {
            orderCategory = '常规订单';
        }
        if (orderData.Type == 'Y2') {
            orderCategory = '项目订单';
        }
        if (orderData.Type == 'Y3') {
            orderCategory = '合作伙伴订单';
        }
        if (this.props.params.id == 6 || this.props.params.id == 9) {
            orderCategory = '常规订单';
        }
        const styleObj = {
            marginBottom: '12px'
        }
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button onClick={this.goBack.bind(this)} style={{float: 'right'}}>取消</Button>
                {/*<Tooltip title="无法保存时，请检查订单内容是否填写完整，如已添加物料行，请尝试修改开单数量。"
                 placement='bottom'
                 arrowPointAtCenter
                 visible={this.state.usable}
        >
          <Button style={{ marginLeft: 10, display: orderSubmit3, float: 'right' }} onClick={this.createHandler2}
                 disabled={this.state.usable}>保存</Button>
        </Tooltip>*/}
                <Button style={{marginLeft: 10, display: orderSubmit3, float: 'right'}} onClick={this.createHandler2}
                        disabled={this.state.usable}>保存</Button>
                <Button onClick={this.showModal}
                        style={{background: '#d61518', color: '#fff', display: orderSubmit4, float: 'right'}}
                        disabled={this.state.usable}>提交</Button>
                <Progress type="circle" percent={!this.state.usable ? 100 : (finishCount / postCount * 100).toFixed(0)}
                          width={30}
                          style={{float: 'right', display: orderSubmit4}}> </Progress>
                <Modal title="注意"
                       visible={confirmvisible}
                       onOk={this.createHandler}
                       confirmLoading={confirmLoading}
                       onCancel={this.handleCancel3}
                >
                    <p>{'提交后将无法修改、删除订单，确认提交订单：'}{this.state.getProCode}{'？请务必仔细核对订单数量、金额是否正确，避免输入错误影响产品发货'}</p>
                </Modal>
                <Button onClick={this.createHandler.bind(this, `${2}`)} style={{
                    background: '#d61518',
                    color: '#fff',
                    marginLeft: 10,
                    display: orderSubmit2,
                    float: 'right',
                }} disabled={this.state.usable}>提交客户审核</Button>
            </DmsTab>
            <div className="dms-table-box">
                <div className="Card-P">
                    <Row>
                        <Col span={8}>
                            <Card title="订单信息" bordered={false} noHovering={true}>
                                <p><label>要货单号：</label>
                                    <span>{this.state.getProCode || '暂无'}</span></p>
                                <p><label>订单编号：</label>
                                    <span>-</span></p>
                                <p><label>订单日期：</label>
                                    <span>{moment(parseInt(detailData.createdDate)).format('YYYY-MM-DD') || ''}</span>
                                </p>
                                <p><label>订单类型：</label>
                                    <span>{orderCategory}</span></p>
                                <p><label>状态：</label>
                                    <span>{this.state.status || '-'}</span></p>
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card title="客户资料" bordered={false} noHovering={true}>
                                <p><label>经销商编号：</label>
                                    <span>{detailData.cusCode}</span></p>
                                <p><label>经销商名称：</label>
                                    <span>{detailData.cusName}</span></p>
                                <p><label>购货单位：</label>
                                    <span>{orderData.PurchaseUnit}</span></p>
                                <p><label>渠道：</label>
                                    <span>{orderData.channel}</span></p>
                                <div style={styleObj}>
                                    <label>{this.state.channelCode === 'PC' ? '承接业务员' : '业务员'}：</label>
                                    <Input value={salesmanName} style={{width: 175}}
                                           onChange={this.salesmanNameChange.bind(this)}/>
                                </div>
                                <div style={styleObj}><label>整单发货：</label>
                                    <span><Select value={this.state.wholeDelivery} style={{width: 160}}
                                                  onChange={this.wholeDeliveryChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
                            </Select></span></div>
                                {/*<p style={{display: this.state.channelCode == 'PC' ? 'display' : 'none'}}>
                 <label>拉动业务员：</label>
                 <Input value={pullmanName} style={{width: 175}}
                 onChange={this.pullmanNameChange.bind(this)}/>
                 </p>
                 <p style={{display: this.state.channelCode == 'PC' ? 'display' : 'none'}}>
                 <label>业务归属渠道：</label>
                 <span>
                 <Select value={this.state.businessChannel} style={{width: 160}}
                 onChange={this.businessChannelChange.bind(this)}
                 disabled={this.state.channelCode == 'PC' ? false : true}>
                 <Option key={1} value={'CT'}>{'工业'}</Option>
                 <Option key={2} value={'DL'}>{'电力'}</Option>
                 <Option key={3} value={'GMJ'}>{'建筑行业'}</Option>
                 <Option key={4} value={'PC'}>{'盘厂'}</Option>
                 </Select>
                 </span></p>*/}
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card title="信用情况" bordered={false} noHovering={true}>
                                <p><label>可用余额：</label>
                                    <span>{orderData.sxeAmount}</span></p>
                                <p><label>开单折扣率：</label>
                                    <span>{orderData.defDiscount || '-'}</span></p>
                                <p><label>项目名称：</label>
                                    <span>{detailData.name || '-'}</span></p>
                                <p><label>质保金：</label>
                                    <span>{'-'}</span></p>
                                <div style={styleObj}><label>项目信息（含终端）：</label>
                                    <span><Select
                                        showSearch
                                        optionFilterProp="children"
                                        value={terminalMessage}
                                        style={{width: 200}}
                                        dropdownMatchSelectWidth={false}
                                        onSelect={this.terminalChange.bind(this)}>
                                        {(optionTerminal || '').map(function (ele, itm) {
                                            return <Option key={itm}
                                                           value={ele.id + ''}>{ele.projectMsg} - {ele.seller}</Option>;
                                        })}
                                    </Select></span>
                                </div>
                                <div style={styleObj}><label>出库单显示单价：</label>
                                    <span><Select value={this.state.deliveryShowprice} style={{width: 100}}
                                                  onChange={this.deliveryShowpriceChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
                            </Select></span></div>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <div style={styleObj}><label>实际收货地址：</label>
                                    <Tooltip
                                        title="收货地址新增、修改或失效，请联系总部物流周春霞"
                                        placement='top'
                                        arrowPointAtCenter
                                    ><span>
							<Select
                                showSearch
                                optionFilterProp="children"
                                value={gatherRealityAddress2}
                                style={{width: 380}}
                                dropdownMatchSelectWidth={false}
                                onSelect={this.addressChange.bind(this)}
                                disabled={shouHuoShow}
                            >
								{(optionAddress || '').map(function (ele, itm) {
                                    return <Option key={itm} value={ele.id + ''}>{ele.detailAddress}</Option>;
                                })}
							</Select>
                                    </span></Tooltip>
                                </div>
                                <div><label>备注：</label>
                                    <Input value={remark}
                                           style={{width: 435}}
                                           maxLength="100"
                                           onChange={this.remarkChange}/></div>
                            </Card>
                        </Col>
                        <Col span={16}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <div style={styleObj}><label>联系人：</label>
                                    <span>{recipientName || '-'}</span>
                                    <label style={{paddingLeft: '30px'}}>联系电话：</label>
                                    <span>{mobile || '-'}</span></div>
                                <div><label>客户订单号：</label>
                                    <Input value={customerOrderCode} style={{width: 200}}
                                           onChange={this.customerOrderCodeChange}/>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
            < div>
                < DmsTab
                    className="white-bg no-border"
                    options={['订单商品']}
                    defaultKey={0}
                />
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        <Button style={{float: 'left'}} onClick={() => this.searchHandler('product')}
                                disabled={id6 || apiFlag}>按物料选择</Button>
                        {button_limits_end.mallHome && <Button style={{marginLeft: 10, float: 'left'}}
                                                               onClick={() => this.searchHandler('merchandise')}
                                                               disabled={id6 || apiFlag}>按商品选型</Button>}
                        <Button style={{marginLeft: 10, float: 'left'}} onClick={this.deleteHandler.bind(this)}
                                disabled={id6 || apiFlag}>删除</Button>
                        <Button style={{float: 'left', marginLeft: 10}} onClick={this.downloadChange.bind(this)}
                                disabled={id6 || apiFlag}>下载模版</Button>
                        <Upload {...uploadParam}>
                            <Button style={{marginLeft: 10}} disabled={id6 || apiFlag}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                        <Button style={{float: 'left', marginLeft: 10}} onClick={this.quickHandler}
                                disabled={id6 || (orgId == null) || apiFlag}>快捷录入</Button>
                        <label style={{marginLeft: 10}}>批量设置提货地点：</label>
                        <Tooltip
                            title="1、开通总部提货，请联系总部物流周春霞。2、预订单转化的订单，自动绑定提货地点，请核对每一行物料后的提货地点"
                            placement='top'
                            arrowPointAtCenter
                        ><span style={{marginLeft: 10}}>
							<Select
                                value={defaultAddress}
                                onChange={this.piLiang.bind(this)}
                                style={{width: 170}}
                                disabled={id6 || apiFlag}
                            >
							        {(tiAddress || '').map(function (ele, itm) {
                                        return <Option key={itm} value={ele.id + ''}>{ele.delvName}</Option>;
                                    })}
                            </Select>
						</span></Tooltip>
                    </div>
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">{'商品总金额：￥' + allPrice}</span></p>
                        {/*<p><span className="right">{'优惠金额：￥' + cutPrice}</span></p>*/}
                        <p><span className="right">{'实际总金额：￥' + realyPrice}</span></p>
                    </div>
                </div>

            </div>

            <Modal visible={quickVisible}
                   title={'快捷录入'}
                   onOk={this.handleOk6}
                   onCancel={this.handleCancel6}
                   confirmLoading={quickLoading}
                   maskClosable={false} width={500}
            >
                <div><TextArea rows={10} placeholder='按[物料编码，数量]或[物料编码 数量]格式录入，多个换行录入'
                               value={quickString}
                               onChange={this.quickChange}></TextArea></div>
            </Modal>

            <Modal
                visible={visible}
                title={<span>
            {activeKey === 'product' ? '选择物料' : '商品选型选择'}（支持Enter回车查询，<span
                    style={{color: 'red'}}> 搜索不到产品？请尝试勾选退市产品</span>）
                    &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                    {button_limits_end.mallHome && <Button size="small"
                                                           onClick={() => this.setState({activeKey: activeKey === 'product' ? 'merchandise' : 'product'})}>{activeKey === 'product' ? '按商品选型' : '按物料选择'}</Button>}
                    {showBackBtn && activeKey !== 'product' && <Button size="small"
                                                                       style={{float: 'right', marginRight: '30px'}}
                                                                       onClick={() => self.refs.mchIframe.contentWindow.history.go(-1)}>返回</Button>}
                        </span>}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
                footer={null}
            >
                {activeKey === 'product' && <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称/编码：</label><Input style={{width: 250}}
                                                                              value={this.state.name}
                                                                              onChange={this.nameChange}
                                                                              onKeyPress={this.keypress}/></Col>
                            <Col span={5}><label>产品分类：</label>
                                <Cascader style={{width: '130px'}} options={tree}
                                          value={cascaderValue}
                                          onChange={this.CascaderChange.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          displayRender={this.CascaderRender.bind(this)}
                                          placeholder=""
                                          popupClassName="popupClass"
                                          showSearch={{filter: this.CascaderFilter}}
                                /></Col>
                            <Col span={4}><label>库存属性：</label>
                                <Select defaultValue="" style={{width: 100}} onChange={this.stockChange}>
                                    <Option value="">全部</Option>
                                    <Option value="0">库存</Option>
                                    <Option value="1">非库存</Option>
                                    <Option value="2">定制</Option>
                                    <Option value="3">专属定制</Option>
                                </Select>
                            </Col>
                            <Col span={2}><Checkbox onChange={this.tsChange}
                                                    disabled={ts_disabled}
                                                    checked={ts_checked}>退市产品</Checkbox></Col>
                            <Col span={3}><Tooltip placement="topLeft"
                                                   title="从您历史一年的开单产品中搜索"
                                                   arrowPointAtCenter><Checkbox onChange={this.lsChange}
                                                                                checked={ls_checked}>历史开单产品</Checkbox></Tooltip></Col>
                            <Col span={2}><Button onClick={this.getAddArray}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                </div>}
                {activeKey === 'merchandise' && <div style={{minHeight: 650}}>
                    <iframe ref="mchIframe" src={merchandiseUrl}
                            style={{width: '100%', height: 650, border: 0}}></iframe>
                </div>}
            </Modal>
        </div>;
    }
}

export default withRouter(CustomOrderAdd);



// WEBPACK FOOTER //
// ./src/routes/order/addConventional.js